import { render, staticRenderFns } from "./IssueAddEdit.vue?vue&type=template&id=33ec25dc&scoped=true"
import script from "./IssueAddEdit.vue?vue&type=script&lang=js"
export * from "./IssueAddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ec25dc",
  null
  
)

export default component.exports